var map = {
	"./banner.png": 962,
	"./bg.svg": 304,
	"./child.png": 202,
	"./content.png": 37,
	"./doc.png": 171,
	"./elderly.png": 636,
	"./fam.png": 570,
	"./logo.png": 949,
	"./mail.png": 510,
	"./megaphone.png": 580,
	"./phone.png": 156,
	"./student.png": 458,
	"./user.png": 315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;